<template>
  <div class="pannel-wrapper white-bg mb-30">
    <div class="panel-heading heading-border">
      <div class="row">
        <div class="col-3">
          <h4 style="padding-top:12px; font-family: Segoe, sans-serif">Últimas alterações</h4>
        </div>
        <div class="col-9 text-right">
          <b-form-select
            v-model="selecionado"
            :disabled="loading || mensagemErro == 'Ainda não temos alterações para as NCMs'"
            @change="atualizaAlteracoes()"
            :options="quantidades"
          ></b-form-select>
        </div>
      </div>
    </div>

    <transition name="exibir">
      <div class="panel-body mt-30 pt-0" v-if="!loading">
        <card :alteracoes="alteracoes" class="efeitoHover" />
        <p v-if="mensagemErro">{{ mensagemErro }}</p>
      </div>
    </transition>

    <div class="text-center" v-if="loading">
      <div class="spinner-border text-primary mt-5 mb-5 text-center" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import MonitoramentoAlteracoes from "../../models/MonitoramentoAlteracoes";
import serviceCookie from "../../services/ServiceCookie";
import card from "../../shared/card";
import service from "../../services/ServiceMonitoramentoAlteracoes";
export default {
  components: {
    card
  },
  data() {
    return {
      recebeArray: [],
      alteracoes: [],
      loading: true,
      usuario: "",
      mensagemErro: "",
      selecionado: 10,
      quantidades: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 75, text: "75" },
        { value: 100, text: "100" }
      ]
    };
  },

  methods: {
    async atualizaAlteracoes() {
      this.loading = true;
      await service
        .getAlteracoes(this.usuario, 50)
        .then(
          res => {
            this.loading = false;
            this.recebeArray = res;

            this.recebeArray.forEach(objeto => {
              let data = "";
              let hora = "";
              if (objeto.Data) {
                data = objeto.Data.substring(0, 10).trim();
                hora = objeto.Data.substring(10).trim();
              }
              this.alteracoes.push(
                new MonitoramentoAlteracoes(
                  objeto.Ncm,
                  objeto.Descricao,
                  objeto.Categoria,
                  data,
                  hora,
                  objeto.ObservacaoConsultor,
                  objeto.Aliquota
                )
              );
            });
          },
          erro => {
            this.loading = false;
            console.log(erro);
          }
        )
        .catch((this.mensagemErro = "Ainda não temos alterações para as NCMs"));
    }
  },

  async created() {
    this.usuario = await serviceCookie.getCookie("idCliente");
    if (this.usuario.length > 0) //this.usuario = this.usuario.substring(3);

    await service
      .getAlteracoes(this.usuario, 50)
      .then(
        res => {
          this.loading = false;
          this.recebeArray = res;

          this.recebeArray.forEach(objeto => {
            let data = "";
            let hora = "";
            data = objeto.Data.substring(0, 10).trim();
            hora = objeto.Data.substring(10).trim();
            this.alteracoes.push(
              new MonitoramentoAlteracoes(
                objeto.Ncm,
                objeto.Descricao,
                objeto.Categoria,
                data,
                hora,
                objeto.ObservacaoConsultor,
                objeto.Aliquota
              )
            );
          });
        },
        erro => {
          this.loading = false;
          console.log(erro);
        }
      )
      .catch((this.mensagemErro = "Ainda não temos alterações para as NCMs"));
  }
};
</script>

<style scoped>
.exibir-enter,
.exibir-leave-to {
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.5s;
}

.spinner-border {
  height: 100px;
  width: 100px;
  font-size: 30px;
}

.efeitoHover:hover {
  cursor: pointer;
}

.custom-select {
  width: 80px;
}
</style>